import Native from './native';


/**
 *
 *
 */
class NativeIOSSport extends Native {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'NativeIOSSport';
    static METHOD_NAME_IOS = 'cbCallBackHandlerCGP';


    /**
     *
     * @param json - parameters to hybrid
     * @public
     */
    callToHandler(json) {
        json = JSON.stringify(json);

        window.webkit.messageHandlers[NativeIOSSport.METHOD_NAME_IOS].postMessage(json);

        return this;
    }

    getParams(params) {
        return params;
    }
}

export default NativeIOSSport;


